<div class="button-list_container">
  @for (button of list; track button.translationKey) {
    <div
      matTooltip="{{ (button.tooltipTranslationKey | translate | titlecase) || (button.translationKey | translate | titlecase) }}"
      matTooltipPosition="above">
      <i
        class="button-list_icon {{ button.iconClass }}"
        [ngClass]="{ 'button-list_icon--disabled faded-more pointer-events-none': button.disabled }"
        (click)="button.action()">
      </i>
    </div>
  }
</div>
